package game

class GameState {
    var shards = 0
    var playerLife = 3
    var playerMaxLife = 3
    var playerCol = 41
    var playerRow = 17
    var roomId = "outdoors-1"

    var lens = false
    var map = false
    var shardScanner = false
    var loreScanner = false
    var itemScanner = false
    var flippers = false
    var lightSource = LightSource.None
    var weapon = Weapon.None
    var armor = Armor.None
    var bracer = Bracer.None
    var jump = Jump.None
    var speed = SpeedUp.None
    var lavaBoots = false
    var divineBoots = false

    var permanentlyRemoved = setOf<String>()
    var lore = mutableSetOf<String>()
    var discovered = mutableSetOf<String>()
}

